import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clinicallergies',
  templateUrl: './clinicallergies.component.html',
  styleUrls: ['./clinicallergies.component.css']
})
export class ClinicallergiesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
